import { AuthState } from '@nike/aegis-auth-react/dist/types/store';
import { useContext } from 'react';
import { AuthContext } from './AuthProvider';

export const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const authBundle = useContext(AuthContext);
  const { isLoggedIn, loginComplete } = authBundle as AuthState;

  if (!isLoggedIn || !loginComplete) {
    return <></>;
  }

  return children;
};